module.exports = "<div>\r\n  <div v-if=\"item.subMenuItemList.filter(function(x) { return x.linkUrl }).length > 0\">\r\n    <a class=\"link\" v-for=\"subItem in item.subMenuItemList.filter(function(x) { return x.linkUrl })\" :id=\"subItem.menuItemId\" :href=\"href(subItem)\" target=\"app-content\" @click=\"setMenuItem(subItem)\">\r\n      <div class=\"menu-item link\" :class=\"levelClass\">\r\n        <div class=\"menu-item-text\" :class=\"{ active: menuItemId === subItem.menuItemId }\">\r\n          {{ subItem.menuItemText }}\r\n        </div>\r\n      </div>\r\n    </a>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/links.html
// module id = 429
// module chunks = 0